import { render, staticRenderFns } from "./SalesSalesSummary.vue?vue&type=template&id=b9453bf2&scoped=true"
import script from "./SalesSalesSummary.vue?vue&type=script&lang=js"
export * from "./SalesSalesSummary.vue?vue&type=script&lang=js"
import style0 from "./SalesSalesSummary.vue?vue&type=style&index=0&id=b9453bf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9453bf2",
  null
  
)

export default component.exports